import type { FC } from 'react';

import { Skeleton } from '@/ui/components/skeleton/skeleton';

export type ChartSkeletonProps = {};
export const ChartSkeleton: FC<ChartSkeletonProps> = () => {
  return <Skeleton className="h-[400px]" />;
};
